module.exports = __webpack_public_path__ + "static/media/iphone.11b85199.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/iphone.png
// module id = 888
// module chunks = 5